import type { PurchaseOrder } from "../domain/models";

export function mergePurchaseOrderRead(rows: PurchaseOrder[], previous: PurchaseOrder[], writes: PurchaseOrder[]) {
  const merged = [...rows];
  for (const written of writes) {
    const index = merged.findIndex(order => order.id === written.id);
    const read = index >= 0 ? merged[index] : undefined;
    const prior = previous.find(order => order.id === written.id);
    let latest = written;
    if (read && read.version > latest.version) latest = read;
    if (prior && prior.version > latest.version) latest = prior;
    if (index >= 0) merged[index] = latest;
    else merged.unshift(latest);
  }
  return merged;
}
